<template>
  <div
    class="c-table-actions"
    :class="{
      'c-table-actions__red': shouldCellBeRed,
      'c-table-actions__blue': shouldCellBeBlue,
    }"
  >
    <m-confirm ref="confirm" mode="danger" />
    <fine-and-bonus-edit-modal ref="editModal" @close="closedEditModal" />

    <div class="c-table-actions__wrapper">
      <div class="c-table-actions__action">
        <svg
          v-if="record.doesRequireExplanatory && record.explanatory.entity && !record.fromCalculation"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Просмотр объяснительной',
            placement: 'bottom',
          }"
          width="13"
          height="15"
          viewBox="0 0 13 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="viewExplanatory"
        >
          <path d="M12 6V14H1V1H7M12 6H7V1M12 6L7 1" stroke="#8E9CBB" stroke-width="2" stroke-linejoin="round" />
        </svg>
        <svg
          v-if="shouldDisplayWriteExplanatoryButton"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Написать объяснительную',
            placement: 'bottom',
          }"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="addExplanatory"
        >
          <path
            d="M14 1L14.9439 1.33035C15.0708 0.967765 14.9788 0.564532 14.7071 0.292894C14.4355 0.0212557 14.0323 -0.0707638 13.6697 0.0561414L14 1ZM9.45 14L8.53619 14.4061C8.70271 14.7808 9.08108 15.0159 9.49076 14.9992C9.90044 14.9825 10.2584 14.7174 10.3939 14.3304L9.45 14ZM1 5.55L0.66965 4.60614C0.282649 4.74159 0.0175448 5.09956 0.000831127 5.50924C-0.0158825 5.91892 0.219182 6.29729 0.593863 6.46381L1 5.55ZM13.0562 0.669648L8.50614 13.6696L10.3939 14.3304L14.9439 1.33035L13.0562 0.669648ZM10.3638 13.5939L7.76384 7.74387L5.93621 8.55614L8.53619 14.4061L10.3638 13.5939ZM7.25616 7.23619L1.40614 4.63619L0.593863 6.46381L6.44389 9.06381L7.25616 7.23619ZM1.33035 6.49386L14.3304 1.94386L13.6697 0.0561414L0.66965 4.60614L1.33035 6.49386ZM13.2929 0.292893L6.14292 7.44289L7.55713 8.85711L14.7071 1.70711L13.2929 0.292893Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>
      <div class="c-table-actions__action fineOrBonus-edit-action">
        <c-button
          v-if="!record.fromCalculation && record.canBeEdited && isAllowedToEdit"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Редактировать',
            placement: 'bottom',
          }"
          icon="edit"
          size="iconic"
          @click="editFineAndBonus"
        />
      </div>
      <div v-if="!record.fromCalculation" class="c-table-actions__action">
        <c-button
          v-if="record.canBeEdited && isAllowedToEdit"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Удалить',
            placement: 'bottom',
          }"
          :icon="{ icon: 'trash', color: 'secondary' }"
          size="iconic"
          @click="deleteFineAndBonus"
        />
      </div>
      <div v-if="record.fromCalculation" class="c-table-actions__action">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: `Сохраненный расчет по филиалу <b>${record.calculation.name}</b> за <b>${record.calculation.date}</b>`,
            placement: 'top',
          }"
          size="iconic"
          icon="calculate"
          @click="goToCalculation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/controls2/Button";
import Confirm from "@/components/modals/confirm-modal";
import FineAndBonusEditModal from "@/pages/fines-and-bonuses/edit-modal";
import { FINE_GROUP_ALT } from "@/constants/fineAndBonusGroups";

export default {
  name: "actions-cell",
  components: {
    "c-button": Button,
    "m-confirm": Confirm,
    FineAndBonusEditModal,
  },
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editModalIsActive: false,
    }
  },

  computed: {
    ...mapGetters({
      isAllowedToEdit: "finesAndBonuses/isAllowedToEdit",
    }),
    shouldCellBeRed() {
      if ("doesRequireExplanatory" in this.record) {
        return this.record.doesRequireExplanatory && !this.record.explanatory.entity;
      }
      return false;
    },
    shouldCellBeBlue() {
      if ("explanatory" in this.record) {
        const { entity, isReviewed } = this.record.explanatory;
        return entity && !isReviewed;
      }
      return false;
    },
    shouldDisplayWriteExplanatoryButton() {
      const { doesRequireExplanatory, explanatory, fromCalculation, canBeEdited } = this.record;
      return doesRequireExplanatory && !explanatory.entity && !fromCalculation && canBeEdited && this.isAllowedToEdit;
    },
  },

  methods: {
    editFineAndBonus() {
      this.$refs.editModal.open(this.record);
      this.$emit('openedEditModal')
      this.editModalIsActive = true
    },
    closedEditModal() {
      this.$emit('closedEditModal')
      this.editModalIsActive = false
    },
    deleteFineAndBonus() {
      this.$refs.confirm.open({
        title: `Удаление  ${this.record.type === FINE_GROUP_ALT ? "штрафа" : "премии"}`,
        text: `Для сотрудника <b>${this.record.fio.value}</b> будет ${
          this.record.type === FINE_GROUP_ALT ? "удален штраф" : "удалена премия"
        } <b>${this.record.reason.value}</b> без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("finesAndBonuses/deleteFineOrBonus", this.record.id.value);
        },
      });
    },
    addExplanatory() {
      this.$emit("addExplanatory", this.record);
    },
    viewExplanatory() {
      this.$emit("viewExplanatory", this.record);
    },
    goToCalculation() {
      const routeData = this.$router.resolve({ path: `/calculation/production?calc_id=${this.record.calculation.id}` });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table-actions {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &__red {
    background-color: #ffe6f2;
  }
  &__blue {
    background-color: #e1edff;
  }
  &__wrapper {
    display: flex;
    padding: 18px 12px;
  }
  &__action {
    width: 16px;
    cursor: pointer;
    &.fineOrBonus-edit-action {
      margin: 2px 14px 0 14px;
    }
  }
}
</style>
